export default __webpack_public_path__ + "img/f20755079218631fa82b342618dcc78c.svg";